import { css } from '@ringcentral/juno';

export const fullSizeStyle = css`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;
